import React, { Component } from 'react'
import autosize from 'autosize'
import noop from 'lodash/noop'
import { AnyAction } from '@reduxjs/toolkit'

type Props = {
  content: string
  placeholder: string
  className?: string
  id?: string
  maxLength?: number
  autoFocus?: boolean
  rows: number
  onChange: (text: string) => void | AnyAction
  onBlur: () => void
  onKeyDown?: () => void
}

export class AdjustableTextarea extends Component<Props> {
  static defaultProps = {
    rows: 1,
    placeholder: '',
    onBlur: noop,
    autoFocus: true,
  }

  componentDidMount(): void {
    // wait for the DOM nodes to actually get rendered
    // setTimeout(this.updateInputSize, 100, true);
    this.updateInputSize(true)

    setTimeout(() => {
      if (this.props.autoFocus) {
        this.focus()
      }
    }, 50)
  }

  focus(): void {
    this.refs.input.focus()
  }

  componentDidUpdate(): void {
    // wait for the DOM nodes to actually get rendered
    setTimeout(this.updateInputSize, 100)
  }

  updateInputSize = didMount => {
    // textarea doesn’t resize automatically adjusting to its content's height;
    // so we resize it after it gets rendered
    if (didMount) {
      autosize(this.refs.input)
    } else {
      autosize.update(this.refs.input)
    }
  }

  onChange = event => {
    event.preventDefault()

    const { maxLength, onChange } = this.props
    const newText = event.target.value

    if (maxLength == null || newText.length <= maxLength) {
      onChange(newText)
    }
  }

  render(): JSX.Element {
    const {
      content,
      placeholder,
      maxLength,
      rows,
      className,
      onKeyDown,
      onBlur,
      id,
    } = this.props

    return (
      <textarea
        ref="input"
        placeholder={placeholder}
        autoCorrect="off"
        spellCheck="false"
        className={className || ''}
        value={content}
        maxLength={maxLength || Infinity}
        rows={rows}
        onChange={this.onChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        id={id}
      />
    )
  }
}
